import React, { useState, useEffect, useRef } from 'react';
import GlobalFunction from './globalFunction';
import './css/micsModule.css';

export default function MicsControlModule({ parameters, onSendMessage }) {
    const [startButtonFontSize, setStartButtonFontSize] = useState(1);
    const [startButtonHeight, setStartButtonHeight] = useState(0);
    const [padding, setPadding] = useState(1);

    const containerRef = useRef(null);
    const fontSizeCheckerRef = useRef(null);

    function updateDimensions() {
        const h = containerRef.current.clientHeight - 2;
        const w = containerRef.current.offsetWidth - (containerRef.current.offsetHeight * 0.2);
        const message = 'Toggle ' + (parameters.config.description.length === 0 ? 'Mics On' : parameters.config.description);
        const fontSize = GlobalFunction.getFontSize(message, w, h - (containerRef.current.clientHeight * 0.4), fontSizeCheckerRef.current);
        setStartButtonFontSize(fontSize);
        setStartButtonHeight(h);
        setPadding(containerRef.current.clientHeight * 0.1);
    }

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        updateDimensions();
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    function handleClick(e) {
        onSendMessage({
            sourceModuleName: parameters.config.module_name,
            event_grouping_seq: parameters.config.event_grouping_seq,
            customerID: parameters.userProfile.customer_id,
            siteID: parameters.userProfile.site_id,
            eventID: parameters.config.event_id,
            action: e.target.name === 'kill' ? 'kill' : 'toggle',
        });
    }

    const message = parameters.config.description.length === 0 ? 'Mics On' : parameters.config.description;
    const rowStyle = { height: parameters.containerHeight.container + 'px' };
    const toggleBtnStyle = {
        position: 'absolute', left: '0', width: '100%', marginTop: '0px',
        fontSize: startButtonFontSize, height: startButtonHeight + 'px',
        lineHeight: startButtonFontSize + 'px', outline: 'none',
        padding: '0 ' + padding + 'px',
    };

    return (
        <div className="outer-container" style={rowStyle} ref={containerRef}>
            <div className="row no-margin">
                <button className={`mics-toggle btn btn-lg btn-${parameters.config.colour}`}
                    style={toggleBtnStyle}
                    name="toggle"
                    onClick={handleClick}
                    type="submit">
                    Toggle {message}
                </button>
            </div>
            <div style={{ position: 'fixed', top: '-2000px', left: '-2000px', backgroundColor: 'pink', whiteSpace: 'pre' }}
                ref={fontSizeCheckerRef} />
        </div>
    );
}
